/**
 * Tiny module-level pub/sub (issue #637 follow-on) so a validation-job event
 * that happens in one part of the tree (the devtool modal triggering a job on
 * the Products page, the Validation Jobs page noticing one of its jobs just
 * finished) can nudge `useValidationJobsSummary`'s nav-indicator poll to run
 * immediately, instead of waiting up to its own interval. The nav indicator,
 * the devtool modal, and the jobs page are siblings under
 * `LgmProductNavigator` with no shared parent state for this — a module
 * singleton avoids threading a callback prop through that unrelated tree.
 */
type Listener = () => void;

const listeners = new Set<Listener>();

export function subscribeValidationJobsPoll(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function notifyValidationJobsPoll(): void {
  listeners.forEach(listener => {
    try {
      listener();
    } catch (err) {
      // A throwing listener must not stop the remaining subscribers (a
      // single unrelated widget's error would otherwise silently drop
      // every other page's poll nudge).
      console.error('validationJobsPollBus: listener threw', err);
    }
  });
}
